import Blank from "@/layouts/blank.vue"

import RoleManagementList from "@/pages/admin/role-management/RolesList.vue";
import RoleManagementAdd from "@/pages/admin/role-management/RoleAdd.vue";
import RoleManagementEdit from "@/pages/admin/role-management/RoleEdit.vue";

const roleManagementRoutes = [
  {
    path: "role-management",
    name: "app-admin-role-management",
    component: Blank,
    children: [
      {
        path: "/",
        redirect: "/app/admin/role-management/list",
      },
      {
        path: "list",
        name: "app-admin-role-management-list",
        component: RoleManagementList,
      },
      {
        path: "add",
        name: "app-admin-role-management-add",
        component: RoleManagementAdd,
      },
      {
        path: "edit",
        name: "app-admin-role-management-edit",
        component: Blank,
        children: [
          {
            path: "/",
            redirect: "/app/admin/role-management/list",
          },
          {
            path: ":id",
            name: "app-admin-role-management-edit-id",
            component: RoleManagementEdit,
          }
        ]
      },
    ]
  },
]

export default roleManagementRoutes